import {css, html, LitElement} from 'lit';
import {customElement, property} from 'lit/decorators';
import {normalizeStyles, typographyStyles} from '@webs/components-library/theming';
import {ifDefined} from 'lit/directives/if-defined.js';

@customElement('webs-cta-link')
export class CtaLink extends LitElement {
  static styles = [
    normalizeStyles,
    typographyStyles,
    css`

      .m-cta-link {
        align-items: center;
        cursor: pointer;
        display: flex;
        padding: 0.75rem 1.25rem;
        place-content: space-between;
        text-decoration: none;
        width: 100%;
      }

      .m-cta-link {
        background: #ecebe9;
        border-radius: 0.4rem;
        margin-bottom: 0.6rem;
      }

      .m-cta-link h6 {
        color: var(--color-base);
        font-family: var(--font-family-heading);
        font-size: 0.75rem;
        font-weight: var(--font-weight-light);
        line-height: 1.5rem;
        margin-bottom: 0;
      }

      .m-cta-link .second-text {
        color: var(--color-orange);
      }

      .m-cta-link .tag {
        margin-left: 0.7rem;
      }

      .m-cta-link .type {
        color: var(--color-orange);
        font-size: 0.75rem;
      }

      .m-cta-link--dark h6 {
        color: var(--color-light-grey);
      }

      .m-cta-link--dark svg circle {
        fill: var(--color-light-grey);
      }

      .m-cta-link--dark:hover h6 {
        color: var(--color-base);
      }

      .m-cta-link--dark:hover svg circle {
        fill: var(--color-base);
      }

      @media only screen and (min-width: 768px) {
        .m-cta-link:hover {
          background: #ecebe9;
          border-radius: 0.4rem;
        }
        .m-cta-link {
          background: transparent;
        }
      }



      @media only screen and (min-width: 1175px) {
        .m-cta-link h6,
        .m-cta-link .type {
          font-size: 1rem;
        }
        .m-cta-link h2 {
          font-size: 2rem;
        }

        .m-cta-link p {
          font-size: 1rem;
        }
      }
    `,
  ];
  @property()
  href: string;

  @property()
  text: string;

  @property({attribute: "second-text"})
  secondText: string;

  @property()
  tag: string;

  @property()
  theme = 'light';

  @property({type: Boolean})
  openinnewtab: boolean;

  protected render(): unknown {
    return html`
      <a class="m-cta-link ${this.theme ? 'm-cta-link--' + this.theme : ''}" href="${this.href}" target="${this.openinnewtab ? '_blank': ''}">
        <h6>
          ${this.text}
          ${this.secondText? html`
            <span class="second-text">
            ${this.secondText}
            </span>
          `
          :""}

          ${this.tag ? html`
              <webs-tag class="tag" text="${this.tag}"></webs-tag>`
            : ``}
        </h6>
        <svg width="12" height="13" viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="9.29085" cy="6.28523" r="2.4593" fill="#181A23"/>
          <circle cx="2.4593" cy="2.4593" r="2.4593" fill="#181A23"/>
          <circle cx="2.4593" cy="10.1107" r="2.4593" fill="#181A23"/>
        </svg>
      </a>
    `;
  }
}
